import styled from "styled-components";
import { Button, Container } from "react-bootstrap";
import { colors, types } from "../../../libs";

export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width:1111px
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const LeftSection = styled.div`
${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CustomButton = styled(Button)`
 background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
    background:  ${colors.background.lightGrey};
  }
`;
export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SaveButton = styled(Button)`
  margin-left: 8px;
`;

export const Description = styled.p`
  font-size: 14px;
  color:  ${colors.text.gray};;
  margin-top: 5px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const SelectTemplateWrapper = styled.div``;